import React, {
  useCallback, useContext, useEffect, useState,
} from 'react';
import { FutureInvestment, PromotionDetail } from 'types/FutureInvestment';
import handlePromise from 'utils/Promise';
import OportunitiesView from 'screens/User/Opportunities/Dashboard/components/View';
import ProjectService from 'services/api/Projects';
import { LoadingContext } from 'context/Loading';
import { useSelector } from 'react-redux';
import { selectUser, selectUserAccount } from 'store/User';
import { ModalErrorContext } from 'context/ModalError';

function Opportunities() {
  const currentUser = useSelector( selectUser );
  const { openErrorModal } = useContext( ModalErrorContext );
  const { toggleLoading } = useContext( LoadingContext );
  const userAccountId = useSelector( selectUserAccount );
  const [futureInvestment, setFutureInvestment] = useState<FutureInvestment | null>( null );
  const [projects, setProjects] = useState<PromotionDetail[] >( [] );

  const getData = useCallback( async () => {
    toggleLoading( true );
    const [, promotionsFundResponse, promotionsFundData] = await handlePromise(
      ProjectService.getPromocionesAndProyectosFondo( ),
    );

    if ( promotionsFundResponse.ok ) {
      const sortedData = ( promotionsFundData?.data ?? [] ).sort(
        ( a: any, b: any ) => new Date( b.createdAt ).getTime() - new Date( a.createdAt ).getTime(),
      );
      setProjects( sortedData as PromotionDetail[] );
    }

    const [, futuraInversionResponse, futuraInversionData] = await handlePromise(
      ProjectService.getFuturainversion( ),
    );

    if ( futuraInversionResponse.ok ) {
      const futuraInversionArray = ( futuraInversionData?.data ?? [] ) as FutureInvestment[];

      const latestFuturaInversion: FutureInvestment | null = futuraInversionArray.length > 0
        ? futuraInversionArray.sort( ( a, b ) => new Date( b.createdAt ).getTime()
      - new Date( a.createdAt ).getTime() )[0]
        : null;
      setFutureInvestment( latestFuturaInversion );
    }

    toggleLoading( false );
  }, [] );

  const opportunityInterestsme = useCallback( async ( ) => {
    toggleLoading( true );

    const [errorResponse, imInterestedResponse] = await handlePromise(
      ProjectService.getFuturainversionImInterested(
        currentUser.userId,
        currentUser.account,
        futureInvestment?.futuraInversionId,
      ),
    );

    if ( imInterestedResponse.ok ) {
      openErrorModal( 'En breve nos pondremos en contacto contigo para ampliar la información.', 'success', 'Gracias' );
    } else {
      openErrorModal( errorResponse.toString() );
    }

    setTimeout( () => {
      toggleLoading( false );
    }, 800 );
  }, [currentUser, futureInvestment] );

  useEffect( () => {
    getData();
  }, [userAccountId] );
  return (
    <OportunitiesView
      projects={projects}
      futureInvestment={futureInvestment}
      opportunityInterestsme={opportunityInterestsme}
    />
  );
}

export default Opportunities;
